<template>
	<notifications class="messages" pause-on-hover>
		<template #body="{ item, close }">
			<sk-toast
				class="message mb-1"
				:level="item.type"
				:text="item.text"
				:theme="contrastTheme"
				:title="item.title"
				:width="width"
				@update:model-value="close"
			/>
		</template>
	</notifications>
</template>

<style lang="scss" scoped>
.messages {
	--ce-message-width: 540px;
	width: var(--ce-message-width) !important;

	top: unset !important;
	bottom: var(--sk-app-bar-height);
	right: calc(50% - (var(--ce-message-width) / 2)) !important;

	:has(> .vue-notification-wrapper) {
		display: flex;
		flex-direction: column;
		gap: var(--sk-spacing-sm);
	}
}
</style>

<script lang="ts" setup>
import { SkToast } from '@silae/components/feedback';
import { useTheme } from '@silae/composables/ui';

withDefaults(
	defineProps<{
		width?: string;
	}>(),
	{
		width: '540px'
	}
);

const { contrastTheme } = useTheme();
</script>
